import { render, staticRenderFns } from "./ConfigurationAditionalForm.vue?vue&type=template&id=0b92beec&"
import script from "./ConfigurationAditionalForm.vue?vue&type=script&lang=js&"
export * from "./ConfigurationAditionalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports